export const sections = {
  BrandPurpose: { name: "Brand Purpose", plural: "Brand Purposes" },
  BlueSkyVision: { name: "Blue Sky Vision", plural: "Blue Sky Visions" },
  CoreValue: { name: "Value", plural: "Values" },
  Strength: { name: "Strength", plural: "Strengths" },
  Weakness: { name: "Weakness", plural: "Weaknesses" },
  Opportunity: { name: "Opportunity", plural: "Opportunities" },
  Threat: { name: "Threat", plural: "Threats" }
}
